<script>
/* eslint-disable no-unused-vars */
export default {
  name: "BaseSelect",
  props: {
    value: {
      type: [String, Number, Boolean],
      required: true
    }
  },
  computed: {
    listeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    }
  },
  methods: {
    input(event) {
      this.$emit("input", event.target.value);
    }
  }
};
</script>
